import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertController } from "@ionic/angular";
import { find } from "rxjs";
import { GlobalsService } from "src/app/api/globals.service";
import { AuthService } from "src/app/services/auth.service";
import { CursosService } from "src/app/services/cursos.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-estudiante-detail-activity",
  templateUrl: "./estudiante-detail-activity.component.html",
  styleUrls: ["./estudiante-detail-activity.component.scss"],
})
export class EstudianteDetailActivityComponent implements OnInit {
  isModalOpen = false;
  @Input() id_actividad: number;
  @Input() id_estudiante: number;
  @Input() curso: any;
  @Input() profile: any;
  actividadActual: any;
  ID: number;
  AUTH_KEY: string;
  avatar = "assets/imagenes/sistema/user1.png";
  dataLoaded = false;
  currentIndex = 0;
  imgUrl = "";
  isCallificable: boolean = false;
  ismobile = false;
  constructor(
    public globalsService: GlobalsService,
    private cursosService: CursosService,
    private authService: AuthService,
    public alertController: AlertController
  ) {
    this.ismobile = globalsService.isMobile;
    this.imgUrl = environment.host + "/";
  }

  ngOnInit() {
    this.loadUserData();
  }

  loadUserData() {
    let promise = new Promise((resolve) => {
      this.authService.userData$.subscribe((res: any) => {
        if (res) {
          this.dataLoaded = true;
          this.ID = res?.id;
          this.AUTH_KEY = res?.auth_key;
          resolve(true);
        }
      });
    });
    promise.then((success) => {
      this.getDetaCalfi();
    });
  }

  getDetaCalfi() {
    // this.data_exercise.name = student.nombre_estudiante;
    // this.studern_select = student;
    this.cursosService
      .getDetailCalf(
        this.AUTH_KEY,
        this.ID,
        this.curso.id,
        this.id_actividad,
        this.id_estudiante
      )
      .subscribe(
        (calfTeach: any) => {
          if (calfTeach) {
            this.actividadActual = calfTeach[0];
            //this.actividadActual = calfTeach[0];
            // this.actividadActual.activities = this.actividadActual.activities.map((act) => {
            //   if (act.tipo === 6) {
            //     return {
            //       ...act,
            //       respuestas: act.respuestas.filter(
            //         (respuesta, index, self) =>
            //           index === self.findIndex((r) => r.respuesta === respuesta.respuesta) // Cambiar 'id' por la propiedad que determine duplicados
            //       ),
            //     };
            //   }
            //   return act; // Deja las demás actividades sin cambios
            // });
          } else {
            console.log(
              "No se recibieron datos de calificaciones de los estudiantes al profesor."
            );
          }
        },
        (error) => {
          console.error("Error al obtener datos de calificaciones:", error);
        }
      );
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  next() {
    if (this.currentIndex < this.actividadActual.activities.length - 1) {
      this.currentIndex++;
    }
  }

  sendCalifOpen(actv) {
    this.cursosService
      .califAbiert(
        this.AUTH_KEY,
        this.ID,
        this.id_estudiante,
        actv.calificacion,
        actv.id_ejercicioActividad,
        actv.observacion,
        actv.id_calificacion
      )
      .subscribe(
        (calfTeach: any) => {
          console.log("Calf Tech", calfTeach);
          if (calfTeach) {
            this.MessageCalification(calfTeach.message);
          }
        },
        (error) => {
          console.error("Error al obtener datos de calificaciones:", error);
        }
      );
  }

  async MessageCalification(message: string) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Confirmar!",
      message: message,
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
          cssClass: "secondary",
          handler: (res) => {
            alert.dismiss();
          },
        },
        {
          text: "Aceptar",
          handler: () => {
            this.isModalOpen = false;
            this.getDetaCalfi();
            alert.dismiss();
          },
        },
      ],
    });

    await alert.present();
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  verActividad(isOpen: boolean, index = 0, calif = false) {
    this.isCallificable = calif;
    this.currentIndex = index;
    this.isModalOpen = isOpen;
  }

  ValidateRespose(response: any, data: any, tipo: number): boolean {
    switch (tipo) {
      case 1:
        var findResponse = data.find(
          (element) => element.opcion === response.opcion
        );
        return findResponse.vf == 1 ? true : false;
      case 2:
        return data.vf && response.respuesta == "v" ? true : false;
      case 3:
        return data.pregunta.includes("[" + response.respuesta + "]");
      case 4:
        var findResponse = data.find(
          (element) => element.input === response.input
        );
        return findResponse.recurso === response.recurso ? true : false;
      case 5:
        var findResponse = data.find(
          (element) => element.code === response.respuesta
        );
        return findResponse ? true : false;
      case 6:
        var findResponse = data.find(
          (element) => element.palabra === response.respuesta
        );
        return findResponse ? true : false;
    }
  }

  findImg(response: any, data: any): any {
    var datafilt = data.filter((element) => element.recurso !== null);

    var findResponse = datafilt.find(
      (element) => element.code === response.respuesta
    );
    return this.imgUrl + findResponse.recurso;
  }

  async setOpen(isOpen: boolean) {
    this.isModalOpen = isOpen;
  }
}
